"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { useConfig } from "./ConfigProvider";

export default function Navigation() {
  const config = useConfig();
  const [mmenuopen, setMenuOpen] = useState(false);
  const [fmenu, setFmenu] = useState(null);
  const [smenu, setSmenu] = useState(null);
  const [lmmenuopen, setLMenuOpen] = useState(false);
  const [activlang, setActivelang] = useState<any>(null);
  const [currentMenu, setcurrentMenu] = useState<any>(null);
  const url = usePathname();

  const langchange = async (e: any, lang: any) => {
    setLMenuOpen(false);
    config.activelang = lang;
    updateConfig(url);
  }
  const setActiveMenu = (e: any, i: any) => {
    e.preventDefault();
    if (fmenu == i) {
      setFmenu(null);
    } else {
      setFmenu(i);
    }
    setSmenu(null);
  }
  const setActiveSubMenu = (e: any, i: any, k: any) => {
    e.preventDefault();
    setSmenu(i);
    if (smenu == k) {
      setSmenu(null);
    } else {
      setSmenu(k);
    }
  }
  const updateConfig = async (url: any) => {
    setLMenuOpen(false);
    const url_language = url?.split('/')[1];
    if (config?.langmenu?.show_menu) {
      let _mlang = await getmatchlang(config, url_language);
      if (_mlang) {
      } else {
        _mlang = await getmatchlang(config, "");
      }
      setcurrentMenu(config?.menu[_mlang?.typo3Language]);
      config.activelang = _mlang;
      setActivelang(_mlang);
    } else {
      setcurrentMenu(config?.menu[0]);
      config.activelang = 0;
      setActivelang(0);
    }
  }

  const getmatchlang = async (config: any, url_language: any) => {
    const matchedLang = config?.langmenu?.langm?.find((_lm: any) => {
      const lng = _lm?.path?.split('/')[1];
      return lng === url_language;
    });
    return matchedLang || null;
  }

  const getLangugeUrl = (_mn: any) => {
    const url_language = url?.split('/')[1];
    const matchedLang = config?.langmenu?.langm?.find((_lm: any) => {
      const lng = _lm?.path?.split('/')[1];
      return lng === url_language;
    });
    let _m = matchedLang || null;
    if (_m) {
      let _furl = url.replace(_m.path.replace(/\/$/, ''), "");
      let _pagedata = config?.pages?.find((pg: any) => {
        return pg?.slug === _furl;
      });
      let oid = _pagedata?.l10n_parent;
      let _fdat = null;
      if (_mn?.uid == 0) {
        _fdat = config?.pages?.find((pg: any) => {
          return pg?.uid === oid;
        });
      } else {
        _fdat = config?.pages?.find((pg: any) => {
          return pg?.l10n_parent === oid && pg?.sys_language_uid === _mn?.uid;
        });
      }
      if (_fdat) {
        return _fdat?.slugurl;
      } else {
        return _mn?.path;
      }
    } else {
      let _pagedata = config?.pages?.find((pg: any) => {
        return pg?.slug === url;
      });
      let _fdat = config?.pages?.find((pg: any) => {
        return pg?.l10n_parent === _pagedata?.uid && pg?.sys_language_uid === _mn?.uid;
      });
      if (_fdat) {
        return _fdat?.slugurl;
      } else {
        return _mn?.path;
      }
    }
    return _mn?.path;
  }

  useEffect(() => {
    updateConfig(url);
  }, []);

  return (
    <>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" onClick={(e) => setMenuOpen(!mmenuopen)} >
        <span className="navbar-toggler-icon"></span>
      </button>
      {currentMenu?.length > 0 ?
        <div className={"collapse navbar-collapse " + (mmenuopen ? "show" : "")} >
          <ul className={`navbar-nav  mb-2 mb-lg-0 mainmenu ${config?.langmenu?.show_menu ? 'm-auto' : 'ml-auto'}`}  >
            {currentMenu?.map((menu: any, k: any) => (
              menu?.detail?.slugurl ?
                <li key={menu?.uid + k + k + 'mmnuloop' + menu?.detail?.title + new Date().getTime()} className={menu?.child?.length > 0 ? 'child nav-item py-2.5  ' : 'nav-item py-2.5  ' + menu?.detail?.title.toLowerCase().replace(/\s+/g, '_')}>
                  <Link
                    className="nav-link"
                    href={
                      // getSlug(menu)
                      menu?.detail?.slugurl
                    }>
                    <span>{
                      // gettitle(menu)
                      menu?.detail?.nav_title !== '' ? menu?.detail?.nav_title : menu?.detail?.title
                    }</span>

                    {menu?.child?.length > 0 ? <svg className={`n-mmneu w-2.5 h-2.5 ms-2.5 my-[auto] mx-[10px] lvl1 ${fmenu == k ? 'inverse' : ''}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6"
                      onClick={(e) => {
                        mmenuopen ?
                          setActiveMenu(e, k)
                          : null
                      }}
                    >
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                    </svg> : null}</Link>

                  {menu?.child?.length > 0 ?
                    <ul className={`level-first dropdown-menu ${fmenu == k ? 'show' : ''}`}>
                      {menu?.child?.map((child: any, i: any) => (
                        <li key={menu?.uid + i + menu?.detail?.title + 'leevel-first' + child?.uid} className={child?.child?.length > 0 ? "dropdown-item children chilld relative" : "dropdown-item children"}>
                          {child?.detail?.slugurl ?
                            <Link
                              className="dropdown-item"
                              href={
                                // getSlug(menu)
                                child?.detail?.slugurl
                              }  >
                              <span>{
                                // gettitle(menu)
                                child?.detail?.nav_title !== '' ? child?.detail?.nav_title : child?.detail?.title
                              }</span>
                              {child?.child?.length > 0 ?
                                <svg className={`lvl2 n-mmneu  ${smenu == i ? 'inverse' : ''}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6" onClick={(e) => {
                                  mmenuopen ?
                                    setActiveSubMenu(e, k, i)
                                    : null
                                }}>
                                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                                </svg>
                                : null}
                            </Link>
                            : null}
                          {child?.child?.length > 0 ?
                            <ul className={`level-sec dropdown-menu ${smenu == i ? 'show' : ''}`}>
                              {child?.child?.map((_child: any, index: any) => (
                                <li key={i + child?.uid + index + _child?.uid + _child?.detail?.title + 'level-sec' + _child?.uid} className="children-level p-[10px]">
                                  {_child?.detail?.slugurl ?
                                    <Link
                                      className="dropdown-item"
                                      href={
                                        // getSlug(menu)
                                        _child?.detail?.slugurl
                                      }   ><span>{
                                        // gettitle(menu)
                                        _child?.detail?.nav_title !== '' ? _child?.detail?.nav_title : _child?.detail?.title
                                      }</span></Link>
                                    : null}
                                </li>
                              ))}
                            </ul>
                            : null}
                        </li>
                      ))}
                    </ul>
                    : null}
                </li>
                : null
            ))}
          </ul>
        </div>
        : <div className={"collapse navbar-collapse h-95 "} >
        </div>}
      {config?.langmenu?.show_menu ?
        config?.langmenu?.langm?.length > 0 ?
          <div className="lang-wrapper custom" >
            <ul>
              {config?.langmenu?.langm?.map((_mn: any, index: any) => (
                activlang?.uid !== _mn?.languageId ?
                  <li key={_mn?.typo3Language + index + 'd-menu'} className="langli" >
                    <Link href={getLangugeUrl(_mn)} onClick={(e) => langchange(e, _mn)}>
                      {config?.langmenu?.pattern == "flag" ?
                        <span className="flex justify-center">
                          <Image
                            priority
                            blurDataURL={`${process.env.NEXT_PUBLIC_DATA_BLUR_URL}`}
                            src={'/Flags/' + _mn?.flagIdentifier?.replace('flags-', '') + '.webp'}
                            alt={_mn?.typo3Language}
                            width={32}
                            height={32}

                          />
                        </span>
                        : config?.langmenu?.pattern == "title_flag" ?
                          <span className="flex flex-row justify-between">
                            <span className="flex">{_mn?.navigationTitle ? _mn?.navigationTitle : _mn?.title}
                            </span>
                            <span className="flex ml-2">
                              <Image
                                priority
                                blurDataURL={`${process.env.NEXT_PUBLIC_DATA_BLUR_URL}`}
                                src={'/Flags/' + _mn?.flagIdentifier?.replace('flags-', '') + '.webp'}
                                alt={_mn?.navigationTitle + "Language"}
                                width={32}
                                height={32}
                              />
                            </span>
                          </span>
                          : config?.langmenu?.pattern == "flag_title" ?
                            <span className="flex flex-row justify-between">
                              <span className="flex ">
                                <Image
                                  priority
                                  blurDataURL={`${process.env.NEXT_PUBLIC_DATA_BLUR_URL}`}
                                  src={'/Flags/' + _mn?.flagIdentifier?.replace('flags-', '') + '.webp'}
                                  alt={_mn?.navigationTitle + "Language"}
                                  width={32}
                                  height={32}
                                />
                              </span>
                              <span className="flex ml-2">{_mn?.navigationTitle ? _mn?.navigationTitle : _mn?.title}
                              </span>
                            </span>
                            : <span>{_mn?.navigationTitle ? _mn?.navigationTitle : _mn?.title}</span>
                      }
                    </Link>
                  </li>
                  : null
              ))}
            </ul>
          </div>
          : <div className="text-center">Loading...</div>
        : null}
    </>

  )
}